exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1[data-v-c780ae46] {\n  margin-bottom: .35em;\n  font-weight: bold;\n}\n.filters[data-v-c780ae46] {\n  margin-bottom: 1.5em;\n}\n.filters .search[data-v-c780ae46] {\n    float: right;\n    margin-top: 20px;\n    width: 220px;\n}\n.filters .filter[data-v-c780ae46] {\n    float: left;\n    margin-right: 1.5em;\n    margin-bottom: .5em;\n}\n.filters .name[data-v-c780ae46] {\n    font-size: .75em;\n    opacity: .7;\n    margin-bottom: .1em;\n}\n.b-table td[data-v-c780ae46] {\n  font-size: .9em;\n}\n", ""]);

// exports
